import { Mesh, ShapeGeometry, FontLoader, Group, MathUtils } from "three";

const loader = new FontLoader();
export const FONT_REGULAR = "FONT_REGULAR";
export const FONT_SEMI_BOLD = "FONT_SEMI_BOLD";
export const FONT_BOLD = "FONT_BOLD";
const fontMap = {
  [FONT_BOLD]: loader.parse(require("../assets/Nunito_Bold.json")),
  [FONT_REGULAR]: loader.parse(require("../assets/Nunito_Regular.json")),
  [FONT_SEMI_BOLD]: loader.parse(
    require("../assets/Nunito_SemiBold_Regular.json")
  ),
};

export function createText(text, material, size, fontType) {
  const font = fontMap[fontType];
  const shapes = font.generateShapes(text, size);
  const geometry = new ShapeGeometry(shapes);
  geometry.computeBoundingBox();
  const xMid = -0.5 * (geometry.boundingBox.max.x - geometry.boundingBox.min.x);
  geometry.translate(xMid, 0, 0);
  return new Mesh(geometry, material);
}

export function createSpacedText(
  text,
  material,
  size,
  bold = false,
  spacing = 1
) {
  const group = new Group();
  for (let i = 0; i < text.length; i++) {
    const mesh = createText(text.charAt(i), material, size, bold);
    mesh.position.x = MathUtils.lerp(-spacing, spacing, i / (text.length - 1));
    group.add(mesh);
  }
  return group;
}

export function guiControls(gui, mesh, position, scale) {
  gui.add(mesh.position, "x", -position, position);
  gui.add(mesh.position, "y", -position, position);
  gui.add(mesh.position, "z", -position, position);
  gui
    .add(mesh.scale, "x", 0.1, scale)
    .name("scale")
    .onChange((value) => {
      mesh.scale.set(value, value, value);
    });
}

export function guiSpacingControls(gui, meshes, spacing) {
  const obj = {
    spacing: 1,
  };
  gui.add(obj, "spacing", 0.1, spacing).onChange((value) => {
    for (let i = 0; i < meshes.length; i++) {
      meshes[i].position.x = MathUtils.lerp(
        -obj.spacing,
        obj.spacing,
        i / meshes.length
      );
    }
  });
}
